module.exports = __webpack_public_path__ + "static/media/woman-chair.15321d77.svg";